import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/home";
import PaginaEnceradeira from "./pages/Pagina-Enceradeira/PaginaEnceradeira";
import PaginaLavadora from "./pages/Home/Pagina-Lavadora/PaginaLavadora";
import PaginaExtratora from "./pages/Home/Pagina-Extratora/PaginaExtratora";
import PaginaCompressor from "./pages/Pagina-Compressor/PaginaCompressor";
import ScrollToTop from "./components/Scroll-to-top/ScrollToTop";

const colors = {
  navy: "#0A1628",
  navyLight: "#0F2040",
  blue: "#1565C0",
  blueLight: "#1E88E5",
  blueBright: "#42A5F5",
  accent: "#00B4D8",
  accentLight: "#48CAE4",
  white: "#FFFFFF",
  offWhite: "#F0F4FA",
  lightGray: "#E8EEF8",
  midGray: "#8FA3C8",
  dark: "#06101E",
  cardBg: "#0D1E35",
  glass: "rgba(255,255,255,0.05)",
  glassHover: "rgba(255,255,255,0.1)",
};

const GlobalStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,300&display=swap');

    *, *::before, *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    html {
      scroll-behavior: smooth;
    }

    body {
      font-family: 'DM Sans', sans-serif;
      background: ${colors.dark};
      color: ${colors.white};
      overflow-x: hidden;
    }

    ::selection {
      background: ${colors.accent};
      color: ${colors.navy};
    }
  `}</style>
);

export default function App() {
  return (
    <>
      <GlobalStyle />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/PaginaEnceradeira" element={<PaginaEnceradeira />} />
        <Route path="/PaginaLavadora" element={<PaginaLavadora />} />
        <Route path="/PaginaExtratora" element={<PaginaExtratora />} />
        <Route path="/PaginaCompressor" element={<PaginaCompressor />} />
      </Routes>
    </>
  );
}